"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var axios_1 = __importDefault(require("axios"));
var config_1 = require("./config");
var url_1 = require("./url");
var util_1 = require("./util");
var cache_1 = require("./cache");
function resolveMockedData(options) {
    try {
        var mockData = typeof (options === null || options === void 0 ? void 0 : options.mock) === 'function' ? options === null || options === void 0 ? void 0 : options.mock(options) : options === null || options === void 0 ? void 0 : options.mock;
        return Promise.resolve(mockData);
    }
    catch (e) {
        return Promise.reject(e);
    }
}
function factory(config) {
    if (config === void 0) { config = {}; }
    function request(method, api, options) {
        var _a;
        var configManager = new config_1.ConfigManager(config);
        var _b = configManager.getAxiosInstanceSetup(), instanceConfig = _b.instanceConfig, customInterceptor = _b.customInterceptor;
        var axiosInstance = axios_1.default.create(instanceConfig);
        axiosInstance.interceptors.response.use(customInterceptor.onFulfilled, customInterceptor.onRejected);
        // 获得axios实例进行副作用设置
        (_a = options === null || options === void 0 ? void 0 : options.applyEffectOnAxiosInstance) === null || _a === void 0 ? void 0 : _a.call(options, axiosInstance, options);
        var cachedAxiosInstance = (0, cache_1.createCachedFunction)(axiosInstance);
        var apiList = configManager.baseConfig.apiList;
        var _c = options || {}, resourceParams = _c.resourceParams, mock = _c.mock, cache = _c.cache, notifyMessage = _c.notifyMessage, showErrorMessage = _c.showErrorMessage, validateResponse = _c.validateResponse, rethrowError = _c.rethrowError, extractData = _c.extractData, extractErrorMessage = _c.extractErrorMessage, transformResponse = _c.transformResponse, isUnauthorized = _c.isUnauthorized, rest = __rest(_c, ["resourceParams", "mock", "cache", "notifyMessage", "showErrorMessage", "validateResponse", "rethrowError", "extractData", "extractErrorMessage", "transformResponse", "isUnauthorized"]);
        // 请求级别的配置在每个请求发出前应用生效
        customInterceptor.applyOptions({
            rethrowError: rethrowError,
            extractData: extractData,
            transformResponse: transformResponse,
            notifyMessage: notifyMessage,
            showErrorMessage: showErrorMessage,
            validateResponse: validateResponse,
            extractErrorMessage: extractErrorMessage,
            isUnauthorized: isUnauthorized,
        });
        var url = (0, url_1.makeUrl)(api, {
            apiList: apiList,
            resourceParams: resourceParams !== null && resourceParams !== void 0 ? resourceParams : {},
        });
        if ((0, util_1.isNullOrUndefined)(mock)) {
            var payload = __assign({ method: method, url: url }, rest);
            if (!cache) {
                return axiosInstance(payload);
            }
            return cachedAxiosInstance(payload);
        }
        var mockParams = __assign({ method: method, url: url }, options);
        return resolveMockedData(mockParams);
    }
    var methods = ['get', ['delete', 'del'], 'head', 'options', 'post', 'put', 'patch'];
    methods.forEach(function (method) {
        var _a = Array.isArray(method) ? method : [method, method], from = _a[0], to = _a[1];
        // @ts-expect-error
        request[to] = request.bind(null, from);
    });
    // Object.setPrototypeOf(request, axiosInstance);
    return request;
}
exports.factory = factory;
